import React from 'react';
import PropTypes from 'prop-types';
import { Components, Utils, translate } from 'versafleet-core';
import { connect } from 'react-redux';
import ReduxActions from 'reduxActions';
import withRouterHooks from 'utils/routerHelper';
import { isUserReadOnly } from 'utils/accessHelper';
import Detail from '../detail';
import CancelDialog from '../cancel/cancelDialog';

class MobileJobViewForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showConfirmDuplicateModal: false,
      duplicatedJobId: null,
    };
  }

  UNSAFE_componentWillMount() {
    Utils.FullScreenLoading.FullScreenLoadingManager.open(this.props.strings.Job.page.loadingItem);
    this.props.dispatch(ReduxActions.job.fetch(Utils.Router.getParams().id))
      .then(() => {
        Utils.FullScreenLoading.FullScreenLoadingManager.close();
      });
  }

  _showDuplicateSuccessMessage = () => {
    Utils.SuccessMessage.SuccessMessageManager.flash((
      <Components.Window.Content
        iconClassName="versa-completed"
      >
        {this.props.strings.Job.page.duplicateSuccess}
        <Components.Link
          onClick={() => {
            Utils.Router.transitionTo(`/jobs/${this.state.duplicatedJobId}`);
          }}
        >
          {this.props.strings.Job.page.goToDuplicatedJob}
        </Components.Link>
      </Components.Window.Content>
    ), 6000);
  }

  _duplicate = async () => {
    Utils.FullScreenLoading.FullScreenLoadingManager.open(
      this.props.strings.Job.page.duplicatingItem,
    );
    const result = await this.props.dispatch(ReduxActions.job.duplicate(this.props.data.id));
    Utils.FullScreenLoading.FullScreenLoadingManager.close();
    this.setState({
      showConfirmDuplicateModal: false,
      duplicatedJobId: result.job.id,
    }, this._showDuplicateSuccessMessage);
    Utils.Router.transitionTo('/jobs');
  }

  _archive = async () => {
    Utils.FullScreenLoading.FullScreenLoadingManager.open(
      this.props.strings.Job.page.archivingItem,
    );
    await this.props.dispatch(ReduxActions.job.archive(this.props.data.id));
    Utils.FullScreenLoading.FullScreenLoadingManager.close();
  }

  _unarchive() {
    Utils.FullScreenLoading.FullScreenLoadingManager.open(
      this.props.strings.Job.page.unarchivingItem,
    );
    this.props.dispatch(ReduxActions.job.unarchive(this.props.data.id))
      .then(() => {
        if (Utils.Helper.isNumber(Utils.Router.getParams().id)) {
          this.props.navigate('/jobs');
        }
      })
      .then(() => {
        Utils.FullScreenLoading.FullScreenLoadingManager.close();
      });
  }

  _isEditable() {
    let isEditable = !isUserReadOnly();
    if (this.props.myjobsSetting) {
      if (['submitted', 'in_progress'].indexOf(this.props.data.state) > -1) {
        isEditable = isEditable && this.props.myjobsSetting.can_edit_after_submission;
      } else if (['completed'].indexOf(this.props.data.state) > -1) {
        isEditable = isEditable && this.props.myjobsSetting.can_edit_after_completion;
      }
    }

    return isEditable;
  }

  _renderNavBar() {
    const data = this.props.data || {};
    const menuItems = [];

    if (!isUserReadOnly()) {
      menuItems.push({
        text: this.props.strings.Job.form.buttons.duplicate,
        action: () => this.setState({ showConfirmDuplicateModal: true }),
        iconClassName: 'versa-copy',
      });
    }
    if (data.state !== 'submitted'
        && data.state !== 'in_progress'
        && data.state !== 'completed'
        && this._isEditable()) {
      menuItems.push({
        text: this.props.strings.Job.form.buttons.addTask,
        action: () => this.props.navigate(`/jobs/${data.id}/new_task`),
        iconClassName: 'versa-add',
      });
    }
    if (this.props.data.archived && this._isEditable()) {
      menuItems.push({
        text: this.props.strings.Job.form.buttons.unarchive,
        action: () => this._unarchive(),
        iconClassName: 'versa-unarchive',
      });
    }

    if (this._isEditable() && this.props.data.cancellable
      && ['draft', 'submitted', 'rejected'].indexOf(this.props.data.state) > -1) {
      menuItems.push({
        text: this.props.strings.Job.form.buttons.cancel,
        action: () => {
          Utils.Dialog.DialogManager.open(
            <CancelDialog dataIds={[this.props.data.id]} shouldPopRoute />,
          );
        },
        iconClassName: 'versa-danger',
      });
    }

    return (
      <Components.Mobile.NavigationBar
        leftButton={Components.Mobile.NavigationBar.buttonConst.CLOSE}
        onLeftButtonClick={() => this.props.navigate('/jobs')}
        renderRightPanel={() => [(
          (!data.archived
            && data.state !== 'in_progress'
            && data.state !== 'completed'
            && this._isEditable()) ? (
              <Components.Button
                iconClassName="versa-edit"
                id="vf-mobile-job__view-form__edit-button"
                onClick={() => this.props.navigate(`/jobs/${Utils.Router.getParams().id}/edit`)}
                showShadow={false}
              />
            ) : false
        ), (menuItems.length !== 0 ? (
          <Components.Mobile.NavigationBarMenu
            items={menuItems}
          >
            {
              !this.props.data.archived && this._isEditable() ? (
                <Components.Archive
                  archive={this._archive}
                  archivePath={() => this.props.navigate('/archives/jobs')}
                  className="vf-job__mobile-view-form__archive-button"
                  ids={[this.props.data.id]}
                  modelName={this.props.strings.Job.constants.job}
                  updateContent={() => {
                    this.props.dispatch(ReduxActions.job.fetchList());
                    this.props.navigate('/jobs');
                  }}
                >
                  <Components.Button
                    iconClassName="versa-archive vf-job__mobile-view-form__archive-button__icon"
                  >
                    {this.props.strings.Job.form.buttons.archive}
                  </Components.Button>
                </Components.Archive>
              ) : false
            }
          </Components.Mobile.NavigationBarMenu>
        ) : false
        )]}
        title={`Job ${data.job_type === 'pickup' ? 'pickup' : 'delivery'} info`}
      />
    );
  }

  _renderActionButton() {
    let action;
    let text;
    let iconClassName;
    let fillColor;
    let color;

    switch (this.props.data.state) {
      case 'draft':
        fillColor = true;
        color = Components.Button.Color.GREEN;
        action = () => {
          Utils.FullScreenLoading.FullScreenLoadingManager.open(
            this.props.strings.Job.page.submittingItem,
          );
          this.props.dispatch(ReduxActions.job.submit(this.props.data.id))
            .then(() => {
              Utils.FullScreenLoading.FullScreenLoadingManager.close();
            });
        };
        text = 'Submit';
        iconClassName = 'versa-business';
        break;
      case 'submitted':
        fillColor = false;
        color = Components.Button.Color.BLUE;
        action = () => {
          Utils.FullScreenLoading.FullScreenLoadingManager.open(
            this.props.strings.Job.page.retractingItem,
          );
          this.props.dispatch(ReduxActions.job.revoke(this.props.data.id))
            .then(() => {
              Utils.FullScreenLoading.FullScreenLoadingManager.close();
            });
        };
        text = 'Retract';
        iconClassName = 'versa-retract';
        break;
      case 'rejected':
        fillColor = true;
        color = Components.Button.Color.GREEN;
        action = () => {
          Utils.FullScreenLoading.FullScreenLoadingManager.open(
            this.props.strings.Job.page.resubmittingItem,
          );
          this.props.dispatch(ReduxActions.job.submit(this.props.data.id))
            .then(() => {
              Utils.FullScreenLoading.FullScreenLoadingManager.close();
            });
        };
        text = 'Resubmit';
        iconClassName = 'versa-business';
        break;
      default:
        // do nothing
    }

    return action ? (
      <Components.Form.MobileMainButton
        color={color}
        fillColor={fillColor}
        iconClassName={iconClassName}
        onClick={action}
      >
        {text}
      </Components.Form.MobileMainButton>
    ) : false;
  }

  _renderConfirmDuplicateModal() {
    const strings = this.props.strings.Job.duplicateDialog;

    return (
      <Components.Modal.Warning
        headerText={strings.header}
        leftButtonOnClick={this._duplicate}
        leftButtonText={strings.confirmButton}
        rightButtonOnClick={() => this.setState({ showConfirmDuplicateModal: false })}
        rightButtonText={strings.cancelButton}
        visible={this.state.showConfirmDuplicateModal}
      >
        {strings.description}
      </Components.Modal.Warning>
    );
  }

  render() {
    if (Utils.Helper.isNullOrUndefined(this.props.data)) {
      return false;
    }

    return (
      <Components.Form.MobileCoreLayout
        footer={this._renderActionButton()}
        header={this._renderNavBar()}
      >
        <Detail data={this.props.data} id="vf-mobile-job__view-form" />
        {this.props.children}
        {this._renderConfirmDuplicateModal()}
      </Components.Form.MobileCoreLayout>
    );
  }
}

MobileJobViewForm.propTypes = {
  children: PropTypes.node,
  data: PropTypes.shape({
    id: PropTypes.number,
    job_type: PropTypes.string,
    state: PropTypes.string,
    archived: PropTypes.bool,
    cancellable: PropTypes.bool,
  }).isRequired,
  dispatch: PropTypes.func.isRequired,
  myjobsSetting: PropTypes.shape({
    can_edit_after_completion: PropTypes.bool,
    can_edit_after_submission: PropTypes.bool,
  }),
  navigate: PropTypes.func.isRequired,
  strings: PropTypes.shape({
    Job: PropTypes.shape({
      constants: PropTypes.shape({
        job: PropTypes.string,
      }),
      duplicateDialog: PropTypes.shape({
        header: PropTypes.string,
        description: PropTypes.string,
        cancelButton: PropTypes.string,
        confirmButton: PropTypes.string,
      }),
      page: PropTypes.shape({
        loadingItem: PropTypes.string,
        duplicatingItem: PropTypes.string,
        archivingItem: PropTypes.string,
        unarchivingItem: PropTypes.string,
        submittingItem: PropTypes.string,
        retractingItem: PropTypes.string,
        resubmittingItem: PropTypes.string,
        duplicateSuccess: PropTypes.string,
        goToDuplicatedJob: PropTypes.string,
      }),
      form: PropTypes.shape({
        buttons: PropTypes.shape({
          duplicate: PropTypes.string,
          addTask: PropTypes.string,
          archive: PropTypes.string,
          unarchive: PropTypes.string,
          cancel: PropTypes.string,
        }),
      }),
    }),
  }).isRequired,
};

MobileJobViewForm.defaultProps = {
  children: null,
  myjobsSetting: null,
};

const mapStateToProps = (state) => {
  const { job, profile } = state;
  return {
    data: job.jobs[Utils.Router.getParams().id],
    myjobsSetting: (profile.profile || {}).myjobs_setting,
  };
};

export default withRouterHooks(connect(mapStateToProps)(translate('')(MobileJobViewForm)));
